import React from 'react';

const Settings = ({ settingsConfig, updateSettings, compact = false }) => {
  return (
    <div>
      {/* <h2>Captions</h2> */}
      <div className="scrollable-container">
        <div className="flex-container">
          <div className="flex-item">
            <label>
              Theme:{' '}
              <select
                value={settingsConfig.layoutTheme}
                onChange={(e) => updateSettings("layoutTheme", e.target.value)}
                className='customSelect'
              >
                <option value="light-theme">Light</option>
                <option value="dark-theme">Dark</option>
                <option value="court-theme">Court</option>
              </select>
            </label>
          </div>

          <div className="flex-item">
            <label>
              Font Size:{' '}
              <input
                type="number"
                value={parseInt(settingsConfig.fontSize, 10)}
                onChange={(e) => updateSettings("fontSize", parseInt(e.target.value, 10))}
                className="customInput"
              />
            </label>
          </div>

          <div className="flex-item">
            <label>
              Font Family:{' '}
              <select
                value={settingsConfig.fontFamily}
                onChange={(e) => updateSettings("fontFamily", e.target.value)}
                className='customSelect'
              >
                <option value="Arial">Arial</option>
                <option value="Times New Roman">Times New Roman</option>
                <option value="Georgia">Georgia</option>
              </select>
            </label>
          </div>

          {!compact && (
            <>
              <div className="flex-item">
                <label>
                  Model:{' '}
                  <select
                    value={settingsConfig.model}
                    onChange={(e) => updateSettings("model", e.target.value)}
                    className='customSelect'
                  >
                    <option value="general">General</option>
                    <option value="enhanced">Enhanced</option>
                    <option value="healthcare">Healthcare</option>
                  </select>
                </label>
              </div>

              <div className="flex-item">
                <label>
                  Language:{' '}
                  <select
                    value={settingsConfig.language}
                    onChange={(e) => updateSettings("language", e.target.value)}
                    className='customSelect'
                  >
                    <option value="en">English</option>
                    <option value="es">Spanish</option>
                    <option value="fr">French</option>
                    <option value="de">German</option>
                  </select>
                </label>
              </div>

              <div className="flex-item">
                <label>
                  Remove Filler Words:{' '}
                  <input
                    type="checkbox"
                    checked={settingsConfig.disfluencies}
                    onChange={(e) => updateSettings("disfluencies", e.target.checked)}
                  />
                </label>
              </div>

              <div className="flex-item">
                <label>
                  Speaker changes:{' '}
                  <input
                    type="checkbox"
                    checked={settingsConfig.speakerDiarization}
                    onChange={(e) => updateSettings("speakerDiarization", e.target.checked)}
                  />
                </label>
              </div>
            </>
          )}
        </div>
      </div>

      {!compact && <div className="separator"></div>}
    </div>
  );
};

export default Settings;